<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardBody>
          <h3>
            {{ $t("Membership.UpdateMembership") }}
          </h3>
          <CAlert :show.sync="dismissCountDown" color="primary" fade>
            ({{ dismissCountDown }}) {{ message }}
          </CAlert>

               <CInput :label="$t('Membership.Title')" type="text" v-model="subscription.title"></CInput>

            <CInput :label="$t('Membership.Price')" type="number" v-model="subscription.price"></CInput>

            <CInput :label="$t('Membership.Description')" type="text" v-model="subscription.description"></CInput>

            <CInput :label="$t('Membership.Duration')" type="number" v-model="subscription.delete_item_after"></CInput>

          <CButton color="success" @click="updateSubscription()" class="w-100"
            >{{ $t("Button.Update") }}</CButton
          >
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { subscriptionService } from "../../_services";
export default {
  name: "EditUser",
  props: {
    caption: {
      type: String,
      default: "User id",
    },
  },
  data: () => {
    return {
      subscription: {
        title: "",
        price: null,
        description: "",
        delete_item_after: null
      },
      product_types: [],
      providers: [],
      message: "",
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
      // this.$router.replace({path: '/users'})
    },
    updateSubscription() {
      let updateSubscription = new FormData();
      updateSubscription.append("title", this.subscription.title);
      updateSubscription.append("price", this.subscription.price);
      updateSubscription.append("description", this.subscription.description);
      updateSubscription.append("delete_item_after", this.subscription.delete_item_after);
      subscriptionService.update(this.$route.params.id, updateSubscription).then(
        function(data) {
          this.message = "updated successfully";
          this.showAlert();
          this.goBack();
        }.bind(this)
      );
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
  },
  mounted() {
    this.loader = this.$loading.show();
    subscriptionService
      .getById(this.$route.params.id)
      .then(
        function(data) {
          this.subscription = data.subscription;
        }.bind(this)
      )
      .finally(
        function() {
          this.loader.hide();
        }.bind(this)
      );
  },
};
</script>
